import React from 'react';
import { useNavigate, Link } from "react-router-dom";
import SupplierFormNew from '@/components/suppliers/SupplierFormNew';
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import PageLayout from "@/components/layout/PageLayout";

const CreateSupplierPage = () => {
  const navigate = useNavigate();

  return (
    <PageLayout maxWidth="lg" padding="md">
      <div className="space-y-6">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link to="/cost-center/suppliers">
              <ArrowLeft className="h-4 w-4 mr-1" />
              Back to Suppliers
            </Link>
          </Button>
        </div>

        <div>
          <h1 className="text-2xl font-bold font-montserrat">Create New Supplier</h1>
          <p className="text-sm text-muted-foreground">
            Add a new supplier to your company
          </p>
        </div>

        <SupplierFormNew />
      </div>
    </PageLayout>
  );
};

export default CreateSupplierPage;
